import React from 'react';
import DiarioMovimientos from '../../../components/insumos/informes/DiarioMovimientos';
import { PageWrapper } from '../../../components/common';

const DiarioMovimientosPage: React.FC = () => {
  return (
    <PageWrapper>
      <DiarioMovimientos />
    </PageWrapper>
  );
};

export default DiarioMovimientosPage;
